import { render, staticRenderFns } from "./SingleBrands.vue?vue&type=template&id=a18ecb3a&scoped=true&"
import script from "./SingleBrands.vue?vue&type=script&lang=js&"
export * from "./SingleBrands.vue?vue&type=script&lang=js&"
import style0 from "./SingleBrands.vue?vue&type=style&index=0&id=a18ecb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18ecb3a",
  null
  
)

export default component.exports